import * as React from 'react';
import { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link, { LinkProps } from '@mui/material/Link';
import AddIcon from '@mui/icons-material/Add';


import { styled, alpha } from '@mui/material/styles';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';


import {
    Link as RouterLink,
    useLocation,
    useNavigate,
    useParams,
} from 'react-router-dom';

import { isEmpty, keys } from 'lodash';

import { useAppSelector } from '../../store/hooks';
import { Button, Divider } from '@mui/material';

import { VocuherCategory, InvoiceRoute, Utils } from "../../utils/common-utils";

interface ILinkRouterProps extends LinkProps {
    to: string;
    replace?: boolean;
}

const breadcrumbNameMap: { [key: string]: string } = {
    '/account': 'My Businesses',
    '/account/create': 'Create',
    '/account/edit': 'Edit',
    '/users': 'Members',
    '/users/create': 'Create',
    '/users/user-details': 'Details',
    '/account/account-info': 'My Business Information',
    '/account/account-details': 'My Business Information',
    '/users/edit': 'Edit',
    //static menu breadcrum
    //End of static menu breadcrum
    '/home': 'Home',
    '/AR': 'AR',
    '/sales': 'Sales',
    '/sales/non-gst-invoice': 'Non GST Invoice',
    '/sales/non-gst-invoice/create': 'Create',
    '/sales/estimate': 'Estimate',
    '/sales/estimate/create': '',
    '/sales/estimate/edit': 'Edit',
    '/sales/credit-note': 'Credit Note',
    '/sales/credit-note/create': '',
    '/sales/credit-note/edit': 'Edit',
    '/sales/debit-note': 'Debit Note',
    '/sales/debit-note/create': '',
    '/sales/debit-note/edit': 'Edit',
    '/sales/invoice': 'Invoice',
    '/sales/invoice/create': 'Create',
    '/sales/invoice/edit': 'Edit',
    '/invoice': 'Invoice',
    '/invoice/view': 'Preview',
    '/AP': 'AP',
    '/account-receivable': 'Invoices',
    '/account-payable': 'Purchase',
    '/account-payable/invoice': 'Invoice',
    '/account-payable/invoice/create': 'Create',
    '/account-payable/invoice/edit': 'Edit',
    '/cashflow': 'Cashflow',
    '/customer': 'Party Details',
    '/suppliers': 'Suppliers',
    '/inventory': 'Inventory',
    '/inventory/view': '',
    '/reports': 'Reports',
    '/report': 'Reports',
    '/expenses': 'Expense Management',
    '/reports/party-ledger': 'Party Ledger',
    '/reports/party-wise-outstanding': 'Party Wise Outstanding',
    '/reports/tds-payable': 'TDS Payable Summary',
    '/reports/tds-receivables': 'TDS Receivable Summary',
    '/reports/tcs-payable': 'TCS Payable Summary',
    '/reports/tcs-receivables': 'TCS Receivable Summary',
    '/account-management': 'Account Management',
    '/my-profile': 'My Profile',
    '/how-to-use-wareozo': 'How To Use Wareozo',
    '/live-chat-support': 'Live Chat Support',
    '/settings' : 'Settings',
    '/payments' : 'Payments',
    '/payments/receipt-application' : 'Receipt Application',
    '/employee': 'Employee',
    '/employee/create': 'New Employee',
    '/employee/edit': 'Edit Employee',
    '/employee/view': 'Employee Details',
};

const LinkRouter = (props: ILinkRouterProps) => (
    <Link {...props} component={RouterLink as any} />
);

/**
 * Breadcrumbs component to show page header.
 */
const CustomBreadcrumbs = () => {
    const params = useParams();

    const location = useLocation();
    const navigate = useNavigate();
    // const { state } = location;
    const pathNames = location.pathname.split('/').filter((pathName) => pathName);
    const { accounts, selectedAccountId } = useAppSelector(state => state.account);
    const { users } = useAppSelector(state => state.users);
    const { inventoryDeatils } = useAppSelector(state => state.inventories);

    // const [name, setName] = useState('');
    let lastParam = '';

    // Handle estimate button
    const handleNewTransaction = (vCategory: string, vType: string) => {
        let redirectTo = '';
        const invoiceMeta = Utils.getInvoiceRouteName(vType);
        if (vCategory && vType){
            redirectTo = `/${vCategory}/invoice/${invoiceMeta.routeName}/create`;
        } 
        // if (path == 'invoice') {
        //     redirectTo = `/sales/${path}/create`;
        // }
        // else if (path == 'estimate') {
        //     redirectTo = `/sales/${path}/create`;
        // } else {
        //     redirectTo = `/sales/${path}/create`;
        // }

        
        navigate(redirectTo);
    };

    /**
     * Set name of the selected account/user.
     */
    useEffect(() => {
        if (!isEmpty(params)) {
            const paramNames = keys(params);

            switch (paramNames[0]) {
                case 'accountId':
                    //const account = accounts.find(account => account._id === params.accountId);

                    //setName(account?.name || '');
                    break;
                case 'userId':
                    const user = users.find(user => user._id === params.userId);

                    if (user && user._id) {
                        breadcrumbNameMap['/users/user-details/' + user._id] = user.name;
                    }

                    //setName(user?.name || '');
                    break;
                case 'inventoryId':
                    if (inventoryDeatils && inventoryDeatils._id) {
                        breadcrumbNameMap['/inventory/view/' + inventoryDeatils._id] = inventoryDeatils.name;
                    }
                    break;
                default:
                    break;
            }
        }

    }, [params, accounts, users, inventoryDeatils])

    return (
        <div>
            {/* Adding `Home` as default to every BreadCrumb path */}
            <Breadcrumbs aria-label="breadcrumb" sx={{ mt: -1.5, ml: 3 }}>
                <LinkRouter
                    underline="hover"
                    color="inherit"
                    fontWeight="bold"
                    to={'/home'}
                    key={'home'}
                >
                    {breadcrumbNameMap['/home']}
                </LinkRouter>
                {pathNames.map((value, index) => {
                    // Skip rendering if it's an ID parameter (24 character hex string)
                    const isIdParam = /^[a-f0-9]{24}$/i.test(value);

                    // Special case: if this is an ID and it's the last element, show the item name
                    if (isIdParam) {
                        if (index === pathNames.length - 1) {
                            // Check if we're on an inventory view page
                            if (pathNames.includes('inventory') && pathNames.includes('view') && inventoryDeatils && inventoryDeatils.name) {
                                // Truncate to first 5 words
                                const words = inventoryDeatils.name.split(' ');
                                const displayName = words.length > 5
                                    ? words.slice(0, 5).join(' ') + '...'
                                    : inventoryDeatils.name;

                                return (
                                    <Typography
                                        key={value}
                                        color="text.primary"
                                        fontWeight="bold"
                                    >
                                        {displayName}
                                    </Typography>
                                );
                            }
                        }
                        return null;
                    }

                    // Skip "view" segment when it's part of inventory/view/[id] pattern
                    if (value === 'view' && pathNames.includes('inventory') && index < pathNames.length - 1) {
                        const nextIsId = /^[a-f0-9]{24}$/i.test(pathNames[index + 1]);
                        if (nextIsId) {
                            return null;
                        }
                    }

                    // if path name is accountID we don't need breadcrumb for the same
                    if (selectedAccountId !== pathNames[index]) {
                        const to = `/${pathNames.slice(0, index + 1).join('/')}`;

                        // Special handling for /invoice/[id]/view pattern
                        const cleanedPath = to.replace(/\/[a-f0-9]{24}/gi, '');

                        // As long as we have params they need to have `underline` and ability to navigate
                        if (index !== pathNames.length - 1 && pathNames.length-2 !== index) {
                            lastParam = to;
                            return (
                                <LinkRouter
                                    underline="hover"
                                    color="inherit"
                                    fontWeight="bold"
                                    to={to}
                                    key={to}

                                >
                                    {breadcrumbNameMap[cleanedPath] || breadcrumbNameMap[to]}
                                </LinkRouter>
                            );
                        } else {
                            lastParam = to;
                            // As this is the last param in the path we are just showing bold without underline.
                            return (
                                <Typography
                                    key={to}
                                    color="text.primary"
                                    fontWeight="bold"

                                >
                                    {breadcrumbNameMap[cleanedPath] || breadcrumbNameMap[to]}
                                </Typography>
                            );
                        }
                    } else
                        return null
                })}
            </Breadcrumbs>

            {/* <Typography sx={{ marginTop: 'px' }} gutterBottom variant="h3" component="div">
                {breadcrumbNameMap[lastParam]}
            </Typography> */}
            {/* <div style={{ display: "flex", flexDirection: 'row', justifyContent: 'flex-end', clear: "both", marginRight: '10px', marginTop: '-20px'}}>

            <div> */}               
                {/* <Button
                // onClick={(e) => handleEditEstimateClick(row)}
                    startIcon={<AddIcon />}
                    variant="contained"
                    color='secondary'
                    // onClick={handleAddCreditNote}
                    style={{ fontSize: '14px', width: '200px', height: '35px', marginLeft: '15px', alignSelf: 'right' }}
                >
                    New Credit Note
                </Button> */}
            {/* </div> */}
        </div>
    );
}

export default CustomBreadcrumbs;
